console.log('*** START *** BASE 64')
import { HypTools } from '@/lib/tools.js'
const hypTools = new HypTools()

function base64encode(str) {
  if (typeof str !== 'string') {
    if (typeof str === 'number') {
      str = str.toString()
    } else {
      throw new Error('Text to encode must be a string or a number.')
    }
  }
  return Buffer.from(str, 'utf8').toString('base64')
}

function base64decode(str) {
  if (typeof str !== 'string') {
    throw new Error('Input value must be a string.')
  }
  return Buffer.from(str, 'base64').toString('utf8')
}

// var hypCrypt = new HypCrypt(null)
export function decodeLoad(load) {
  if (load === undefined || load === null || load.length === 0) {
    // console.warn('==== W A R N ==== load is (%s)', load)
    return ''
  }
  // return base64decode(load)
  if (hypTools.isBase64(load)) {
    return base64decode(load)
  } else {
    return load
  }
}

export function encodeLoad(load) {
  //  return base64encode(load)
  if (hypTools.isBase64(load)) {
    return load
  } else {
    return base64encode(load)
  }
}

const encodeBuffer = (buffer) => buffer.toString('base64')
const encodeString = (string) => encodeBuffer(Buffer.from(string))
const encodeData = (data) => encodeString(JSON.stringify(data))

export const encode = (data) => {
  if (Buffer.isBuffer(data)) return encodeBuffer(data)
  if (typeof data === 'string') return encodeString(data)
  return encodeData(data)
}

export const decode = (string) => {
  const decoded = Buffer.from(string, 'base64').toString()
  try {
    return JSON.parse(decoded)
  } catch (e) {
    return decoded
  }
}

console.log('*** DONE *** BASE 64')

// module.exports = { decodeLoad, encodeLoad, encode, decode }
